import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';

const Pill = styled.div<{ $filled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 1000px;
  white-space: nowrap;
  background: ${({ theme, $filled }) => ($filled ? theme.colors.cultured : theme.colors.white)};
  ${({ theme, $filled }) => !$filled && `border: 1px solid ${theme.colors.stroke};`}
`;

interface LabelChipProps {
  label: string;
  value: string;
  filled?: boolean;
}

export const LabelChip: React.FC<LabelChipProps> = ({ label, value, filled }) => (
  <Pill $filled={filled}>
    <Poppins px={14} color="cflowerBlue">
      {label}:
    </Poppins>
    <Poppins px={14} weight={500} color="prussianBlue">
      {value}
    </Poppins>
  </Pill>
);
